import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Content, VirtualScroll } from "ionic-angular";
import { CheckUtils } from "../../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n <ion-content (ionScroll)=\"onScroll($event)\">\n\t  <ion-list *ngIf=\"datas !=null\" [virtualScroll]=\"datas\" [approxItemHeight]=\"'86px'\">\n\t    <ion-item *virtualItem=\"let data;let i=index; let last = last;\">\n\t      <od-conversation class=\"od-conversations-item\" [data]=\"data\" (click)=\"onOpenConversationClick(data)\"></od-conversation>\n\t    {{onRestoreScroll(data,i)}}\n\t    </ion-item>\n\t  </ion-list>\n\t  \n\t\t <div class=\"od-conversations-empty\"  *ngIf=\"datas ==null || datas.length === 0\">\n\t\t {{ 'Conversations.empty' | translate }}\n\t\t </div>\t \n\t    <ion-infinite-scroll (ionInfinite)=\"$event.waitFor(doInfinite($event))\">\n\t    <ion-infinite-scroll-content></ion-infinite-scroll-content>\n\t  </ion-infinite-scroll>\n \n  </ion-content>\n";
var CSS_STYLE = "\n.od-conversations-item{\n\tcursor:pointer;\n}\n\n.od-conversations-empty {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 50%;\n    position: absolute;\n    width: 100%;\n    color: hsl(222,18%, 89%);\n    font-size: 24px;\n}\n";
var Conversations = /** @class */ (function () {
    function Conversations() {
        var _this = this;
        this.openConversationClick = new EventEmitter();
        this.conversationLoad = new EventEmitter();
        this.scroll = new EventEmitter();
        this.scrollTop = 0;
        this._index = 1;
        window.onresize = function () {
            if (_this.listView != null && _this.datas != null && _this.datas.length != 0) {
                if (_this.listView._cells != null) {
                    _this.listView.readUpdate(true);
                    _this.listView.renderVirtual(false);
                    _this.listView.resize();
                }
            }
        };
    }
    Conversations.prototype.onOpenConversationClick = function (data) {
        this.openConversationClick.emit(data);
    };
    Conversations.prototype.onRestoreScroll = function (data, index) {
        if (this._index < index && !CheckUtils.isEmpty(this.scrollTop)) {
            this.content.scrollTo(0, this.scrollTop);
            this.scrollTop = null;
        }
        this._index = index;
    };
    Conversations.prototype.onScroll = function () {
        this.scroll.emit({ x: this.content.scrollLeft, y: this.content.scrollTop });
    };
    Conversations.prototype.doInfinite = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.conversationLoad.emit(resolve);
        });
    };
    Conversations.decorators = [
        { type: Component, args: [{
                    selector: "od-conversations",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Conversations.ctorParameters = function () { return []; };
    Conversations.propDecorators = {
        "scrollTop": [{ type: Input },],
        "content": [{ type: ViewChild, args: [Content,] },],
        "listView": [{ type: ViewChild, args: [VirtualScroll,] },],
        "datas": [{ type: Input },],
        "openConversationClick": [{ type: Output },],
        "conversationLoad": [{ type: Output },],
        "scroll": [{ type: Output },],
    };
    return Conversations;
}());
export { Conversations };
//# sourceMappingURL=conversations.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/chat/conversation/conversations.js
// module id = 435
// module chunks = 14